function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.6141 1L18.4999 4.88578L14.6141 8.77156",
  stroke: "#023365",
  strokeWidth: 1.13351,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.01318 10.7151V8.77226C1.01318 7.74168 1.42258 6.75332 2.1513 6.02459C2.88003 5.29587 3.86839 4.88647 4.89896 4.88647H18.4992",
  stroke: "#023365",
  strokeWidth: 1.13351,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3866 20.9998L6.50079 17.1141L10.3866 13.2283",
  stroke: "#023365",
  strokeWidth: 1.13351,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9868 11.2856V13.2285C23.9868 14.2591 23.5774 15.2475 22.8487 15.9762C22.12 16.7049 21.1316 17.1143 20.101 17.1143H6.50079",
  stroke: "#023365",
  strokeWidth: 1.13351,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgTransfer = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 22,
  viewBox: "0 0 25 22",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransfer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transfer.be78093c.svg";
export { ForwardRef as ReactComponent };